export const translations = {
  en: {
    navbar: {
      home: "Home",
      about: "About",
      yachts: "Yachts",
      contact: "Contact",
      language: "Language"
    },
    hero: {
      label: "EXCLUSIVE YACHT EXPERIENCES",
      title: "Embark on a Journey of\nElegance and Adventure\nwith Our Yachts",
      description: "Discover the breathtaking beauty of the coastline with our luxury yacht tours. Departing from Side's historic harbor, explore hidden sea caves, pristine beaches, and iconic landmarks.",
      button: "RESERVE YOUR YACHT →"
    },
    welcome: {
      title: "Discover Your Perfect Yacht Adventure",
      subtitle: "Experience luxury and freedom on the Turkish Riviera",
      description: "Embark on an unforgettable journey along Turkey's stunning coastline, where crystal-clear waters meet ancient history and modern luxury.",
      features: {
        premium: {
          title: "Premium Yachts",
          description: "Choose from our fleet of meticulously maintained luxury vessels"
        },
        routes: {
          title: "Custom Routes",
          description: "Personalized itineraries tailored to your preferences"
        },
        crew: {
          title: "Expert Crew",
          description: "Professional and experienced crew at your service"
        },
        luxury: {
          title: "Luxury Experience",
          description: "First-class amenities and gourmet dining options"
        }
      }
    },
    features: {
      yachtCharters: {
        title: "Luxury Yacht Charters",
        description: "Sail in style with our fleet of premium yachts, offering unparalleled comfort and elegance."
      },
      service: {
        title: "Exceptional Service",
        description: "Our dedicated crew ensures a seamless and memorable experience, catering to your every need."
      },
      fleet: {
        title: "Top-Tier Fleet",
        description: "Our yachts are meticulously maintained to the highest standards, ensuring a safe and luxurious journey."
      }
    },
    yachtListings: {
      title: "SPECIAL YACHT TRIPS",
      subtitle: "Our fleet of luxury yachts",
      viewAll: "View All Yachts",
      details: {
        capacity: "Capacity",
        cabins: "Cabins",
        location: "Location"
      }
    },
    infoSection: {
      banner: {
        title: "Let's discover amazing luxury yacht today!",
        button: "BOOK NOW →"
      },
      images: {
        mainImageAlt: "Luxury yacht at sunset",
        overlayImageAlt: "Captain steering the yacht",
        promoImageAlt: "Luxury yacht experience"
      },
      discover: {
        label: "DISCOVER",
        title: "Discover best yacht",
        description1: "Our Side Yacht Tour takes place on a family-run yacht. If you are not familiar with this style of vessel, it's a wooden sailing vessel commonly found in the southwest of Turkey and the eastern Mediterranean.",
        description2: "The vessel will be yours for the day and is equipped with modern toilets, TVs, comfortable cushions, loungers, and seatings on board."
      },
      benefits: {
        expertise: {
          title: "Local Expertise",
          description: "Our experienced crew knows every hidden gem along the Turkish coast for an authentic experience."
        },
        service: {
          title: "Premium Service",
          description: "First-class amenities and dedicated crew at your service."
        },
        personalized: {
          title: "Personalized Service",
          description: "Tailored itineraries and premium onboard services designed to exceed your expectations."
        }
      },
      features: {
        label: "FEATURES",
        title: "Experience Luxury",
        description: "Discover the perfect blend of comfort and adventure"
      },
      charter: {
        title: "Private Charter",
        description: "Exclusive yacht experiences tailored to your preferences"
      },
      amenities: {
        title: "Modern Amenities",
        description: "Fully equipped with the latest comfort features"
      },
      crew: {
        title: "Professional Crew",
        description: "Experienced and dedicated team at your service"
      },
      promo: {
        title: "Special Summer Offers",
        description: "Book your dream yacht experience now and enjoy up to 20% off on selected dates. Early bird discounts and flexible booking options available.",
        button: "VIEW OFFERS"
      }
    },
    tourRoadmap: {
      title: "TOUR ROUTE",
      subtitle: "Your Journey With Us",
      description: "Experience an unforgettable day exploring the beautiful Mediterranean coast",
      stops: [
        {
          time: "10:00",
          location: "Side Harbor",
          description: "Departure from Side Harbor"
        },
        {
          time: "10:30",
          location: "Swimming Break",
          description: "First swimming and snorkeling stop"
        },
        {
          time: "12:30",
          location: "Lunch Break - Swimming",
          description: "Enjoy your lunch with Mediterranean cuisine"
        },
        {
          time: "14:00",
          location: "Swimming Break",
          description: "Second swimming and relaxation time"
        },
        {
          time: "15:00",
          location: "Side Harbor",
          description: "Return to Side Harbor"
        }
      ]
    },
    about: {
      hero: {
        title: "About Side Vip Yacht Rental",
        subtitle: "Crafting Unforgettable Maritime Experiences Since 2020"
      },
      story: {
        title: "Our Story",
        description1: "Founded in 2020, Side VIP Yacht Charter has established itself as a premier luxury yacht charter service in Side, Turkey. Our journey began with a simple vision: to provide exceptional maritime experiences that combine luxury, comfort, and adventure.",
        description2: "Today, we pride ourselves on our fleet of meticulously maintained yachts and our dedicated team of experienced professionals who ensure every voyage exceeds expectations."
      },
      values: {
        title: "Our Values",
        cards: {
          excellence: {
            title: "Excellence",
            description: "We strive for excellence in every aspect of our service"
          },
          safety: {
            title: "Safety First",
            description: "Your safety is our top priority on every journey"
          },
          luxury: {
            title: "Luxury Service",
            description: "Premium experiences tailored to your preferences"
          },
          trust: {
            title: "Trust",
            description: "Building lasting relationships through reliability"
          }
        }
      },
      stats: {
        experience: "Years of Experience",
        clients: "Happy Clients",
        satisfaction: "Client Satisfaction"
      },
      location: {
        title: "Our Location",
        description: "Located in the heart of Side, Turkey, conveniently near the historic harbor. We are perfectly positioned to serve your yacht charter needs along the Turkish Riviera.",
        contact: {
          title: "Contact Information",
          address: "Side Harbour, Side, Apollon Sk., 07600 Manavgat/Antalya",
          phone: "+90 549 537 70 07",
          email: "side.viprental@gmail.com"
        }
      }
    },
    contact: {
      header: {
        title: "Contact Us",
        subtitle: "Get in touch with us for any questions or inquiries"
      },
      info: {
        phone: {
          title: "Phone",
          numbers: [
            "+90 549 537 70 07",
            "+90 549 537 70 07"
          ]
        },
        email: {
          title: "Email",
          addresses: [
            "info@sidevipyacht.com",
            "support@sidevipyacht.com"
          ]
        },
        location: {
          title: "Location",
          address: [
            "Side Harbour, Side, Apollon Sk., 07600 Manavgat/Antalya",
            "Side, Antalya, Turkey"
          ]
        }
      },
      form: {
        title: "Send us a message",
        fields: {
          name: {
            label: "Name",
            placeholder: "Your name"
          },
          email: {
            label: "Email",
            placeholder: "Your email address",
            hint: "Add your email address that you want us to contact you"
          },
          phone: {
            label: "Phone",
            placeholder: "+90 XXX XXX XXXX",
            hint: "Add your phone number that you want us to contact you"
          },
          subject: {
            label: "Subject",
            placeholder: "Message subject"
          },
          message: {
            label: "Message",
            placeholder: "Your message"
          }
        },
        submitButton: "Send Message"
      }
    },
    timeOptions: {
      title: "Select Your Time",
      morning: "Morning Tour",
      afternoon: "Afternoon Tour",
      sunset: "Sunset Tour",
      fullDay: "Full Day Tour",
      morningTime: "10:00 - 14:00",
      afternoonTime: "14:00 - 18:00",
      sunsetTime: "18:00 - 22:00",
      fullDayTime: "10:00 - 18:00"
    },
    paymentContact: {
      title: "Contact for Booking",
      yacht: "Selected Yacht",
      price: "Starting Price",
      messageTemplate: "Hello, I'm interested in booking the {yachtName}",
      emailSubject: "Booking Inquiry for {yachtName}",
      buttons: {
        whatsapp: "Contact via WhatsApp",
        telegram: "Contact via Telegram",
        email: "Contact via Email"
      }
    },
    maps: {
      sectionTitle: {
        subtitle: "OUR LOCATION",
        title: "Find Us Here"
      },
      title: "Our Location",
      markerTitle: "Side VIP Yacht Charter",
      popup: "Our Yacht Rental Location"
    },
    yachtDetails: {
      header: {
        price: "Starting from"
      },
      description: {
        title: "Description",
        specialOffer: "OUR SPECIAL OFFER INCLUDED IN THE PRICE",
        readMore: "Read More...",
        location: {
          departure: "Departure Marina"
        },
        menu: {
          title: "Menu",
          beverages: "Fruity Soft Drinks"
        },
        extraServices: {
          title: "FOR EXTRA SERVICES AND REQUESTS NOT INCLUDED IN THE PRICE"
        }
      },
      features: {
        title: "The Features of",
        labels: {
          yachtName: "Yacht Name",
          yachtType: "Yacht Type",
          brand: "Brand",
          capacity: "Capacity",
          crew: "Crew",
          cabin: "Cabin",
          showerWC: "Shower/WC",
          length: "Length",
          width: "Width",
          speed: "Speed",
          manufacturing: "Manufacturing",
          refitDate: "Refit Date",
          location: "Location",
          distance: "Distance"
        }
      },
      equipment: {
        title: "The Equipment of"
      },
      services: {
        included: {
          title: "Included in Price",
          fixedMenu: {
            title: "Fixed Menu"
          }
        },
        extras: {
          title: "Available Extras"
        }
      },
      imageViewer: {
        close: "Close",
        prev: "Previous",
        next: "Next"
      }
    },
    yachtData: {
      priceUnit: "per day",
      description: {
        highlights: "Highlights",
        location: {
          departure: "Departure",
          route: "Route"
        }
      },
      features: {
        title: "Features",
        labels: {
          yachtName: "Yacht Name",
          yachtType: "Yacht Type",
          brand: "Brand",
          capacity: "Capacity",
          crew: "Crew",
          cabin: "Cabins",
          showerWC: "Shower/WC",
          length: "Length",
          width: "Width",
          speed: "Speed",
          manufacturing: "Manufacturing Year",
          refitDate: "Refit Date",
          location: "Location",
          distance: "Distance"
        }
      },
      equipment: {
        title: "Equipment",
        comfort: "Comfort Equipment",
        activities: "Activities"
      },
      services: {
        included: {
          foodAndBeverage: {
            title: "Food and Beverage",
            description: "Complimentary menu and non-alcoholic beverages included."
          },
          decoration: {
            title: "Decoration",
            description: "Custom decorations available for special occasions."
          },
          fuel: {
            title: "Fuel",
            description: "All fuel costs included in charter price."
          },
          waiterAndCrew: {
            title: "Waiter and Crew",
            description: "Professional crew service included."
          },
          fixedMenu: {
            title: "Fixed Menu Content"
          }
        },
        extras: {
          birthdayCake: {
            title: "Birthday Cake",
            description: "Custom birthday cakes available on request."
          },
          bringingAlcohol: {
            title: "Bringing Alcohol",
            description: "25€ service charge for bringing own alcohol."
          },
          purchasingAlcohol: {
            title: "Purchasing Alcohol",
            description: "Available for purchase onboard."
          },
          modifyingMenu: {
            title: "Menu Modifications",
            description: "Custom menu options available at additional cost."
          },
          tourRouteChange: {
            title: "Route Changes",
            description: "Flexible routing with additional time charges."
          },
          waterActivities: {
            title: "Water Activities",
            description: "Additional water sports available for fee."
          },
          photographyServices: {
            title: "Photography",
            description: "Professional photo services available."
          },
          transfer: {
            title: "Transfer",
            description: "Custom transfer services based on group size."
          }
        }
      }
    }
  },
  tr: {
    navbar: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      yachts: "Yatlar",
      contact: "İletişim",
      language: "Dil"
    },
    hero: {
      label: "ÖZEL YAT DENEYİMLERİ",
      title: "Yatlarımızla\nZarafet ve Macera\nYolculuğuna Çıkın",
      description: "Lüks yat turlarımızla sahil şeridinin nefes kesen güzelliğini keşfedin. Side'nin tarihi limanından hareketle, gizli deniz mağaralarını, el değmemiş plajları ve simgesel noktaları keşfedin.",
      button: "YATINIZI AYIRTIN →"
    },
    welcome: {
      title: "Mükemmel Yat Maceranızı Keşfedin",
      subtitle: "Türk Rivierası'nda lüks ve özgürlüğü yaşayın",
      description: "Kristal berraklığındaki suların antik tarih ve modern lüksle buluştuğu Türkiye'nin muhteşem sahil şeridinde unutulmaz bir yolculuğa çıkın.",
      features: {
        premium: {
          title: "Premium Yatlar",
          description: "Özenle bakımı yapılan lüks teknelerimizden seçim yapın"
        },
        routes: {
          title: "Özel Rotalar",
          description: "Tercihlerinize göre özelleştirilmiş rotalar"
        },
        crew: {
          title: "Uzman Ekip",
          description: "Profesyonel ve deneyimli ekip hizmetinizde"
        },
        luxury: {
          title: "Lüks Deneyim",
          description: "Birinci sınıf olanaklar ve gurme yemek seçenekleri"
        }
      }
    },
    features: {
      yachtCharters: {
        title: "Lüks Yat Kiralama",
        description: "Eşsiz konfor ve zarafet sunan premium yatlarımızla denize açılın."
      },
      service: {
        title: "Olağanüstü Hizmet",
        description: "Özel ekibimiz, her ihtiyacınızı karşılayarak unutulmaz bir deneyim yaşamanızı sağlar."
      },
      fleet: {
        title: "Üst Düzey Filo",
        description: "Yatlarımız, güvenli ve lüks bir yolculuk için en yüksek standartlarda bakımı yapılmaktadır."
      }
    },
    yachtListings: {
      title: "ÖZEL YAT TURLARI",
      subtitle: "Lüks yat filomuz",
      viewAll: "Tüm Yatları Görüntüle",
      details: {
        capacity: "Kapasite",
        cabins: "Kabin",
        location: "Konum"
      }
    },
    infoSection: {
      banner: {
        title: "Bugün muhteşem lüks yatı keşfedin!",
        button: "ŞİMDİ REZERVASYON YAP →"
      },
      images: {
        mainImageAlt: "Gün batımında lüks yat",
        overlayImageAlt: "Kaptanın yatı yönetmesi",
        promoImageAlt: "Lüks yat deneyimi"
      },
      discover: {
        label: "KEŞFET",
        title: "En iyi yatı keşfedin",
        description1: "Side Yat Turumuz aile işletmesi olan bir yatta gerçekleşiyor. Bu türnekte aşina değilseniz, Türkiye'nin güneybatısında ve Doğu Akdeniz'de yaygın olarak bulunan ahşap bir yelkenli teknedir.",
        description2: "Tekne gün boyunca sizin olacak ve modern tuvaletler, televizyonlar, rahat minderler, şezlonglar ve oturma yerleriyle donatılmıştır."
      },
      benefits: {
        expertise: {
          title: "Yerel Uzmanlık",
          description: "Deneyimli ekibimiz, otantik bir deneyim için Türk sahillerindeki her gizli noktayı bilir."
        },
        service: {
          title: "Premium Hizmet",
          description: "Birinci sınıf olanaklar ve özel ekip hizmetinizde."
        },
        personalized: {
          title: "Kişiselleştirilmiş Hizmet",
          description: "Beklentilerinizi aşmak için tasarlanmış özel rotalar ve premium yat içi hizmetler."
        }
      },
      features: {
        label: "ÖZELLİKLER",
        title: "Lüksü Deneyimleyin",
        description: "Konfor ve maceranın mükemmel uyumunu keşfedin"
      },
      charter: {
        title: "Özel Kiralama",
        description: "Tercihlerinize göre özelleştirilmiş yat deneyimleri"
      },
      amenities: {
        title: "Modern Olanaklar",
        description: "En son konfor özellikleriyle tam donanımlı"
      },
      crew: {
        title: "Profesyonel Ekip",
        description: "Deneyimli ve özel ekip hizmetinizde"
      },
      promo: {
        title: "Özel Yaz Kampanyaları",
        description: "Hayalinizdeki yat deneyimini şimdi rezerve edin ve seçili tarihlerde %20'ye varan indirimlerden yararlanın. Erken rezervasyon indirimleri ve esnek rezervasyon seçenekleri mevcuttur.",
        button: "KAMPANYALARI GÖR"
      }
    },
    tourRoadmap: {
      title: "TUR ROTASI",
      subtitle: "Bizimleki Yolculuğunuz",
      description: "Güzel Akdeniz kıyılarını keşfederek unutulmaz bir gün geçirin",
      stops: [
        {
          time: "10:00",
          location: "Side Limanı",
          description: "Side Limanı'ndan hareket"
        },
        {
          time: "10:30",
          location: "Yüzme Molası",
          description: "İlk yüzme ve şnorkel molası"
        },
        {
          time: "12:30",
          location: "Öğle Yemeği ve Yüzme",
          description: "Akdeniz mutfağından öğle yemeği keyfi"
        },
        {
          time: "14:00",
          location: "Yüzme Molası",
          description: "İkinci yüzme ve dinlenme zamanı"
        },
        {
          time: "15:00",
          location: "Side Limanı",
          description: "Side Limanı'na dönüş"
        }
      ]
    },
    about: {
      hero: {
        title: "Side VIP Yat Kiralama Hakkında",
        subtitle: "2020'den Beri Unutulmaz Deniz Deneyimleri Yaratıyoruz"
      },
      story: {
        title: "Hikayemiz",
        description1: "2020 yılında kurulan Side VIP Yat Kiralama, Side, Türkiye'de önde gelen lüks yat kiralama hizmeti olarak kendini kanıtlamıştır. Yolculuğumuz basit bir vizyonla başladı: lüks, konfor ve macera sunan olağanüstü deniz deneyimleri sağlamak.",
        description2: "Bugün, özenle bakımı yapılan yat filomuz ve her seyahatin beklentileri aşmasını sağlayan deneyimli profesyonellerden oluşan ekibimizle gurur duyuyoruz."
      },
      values: {
        title: "Değerlerimiz",
        cards: {
          excellence: {
            title: "Mükemmellik",
            description: "Hizmetimizin her alanında mükemmelliği hedefliyoruz"
          },
          safety: {
            title: "Önce Güvenlik",
            description: "Her yolculukta güvenliğiniz önceliğimizdir"
          },
          luxury: {
            title: "Lüks Hizmet",
            description: "Tercihlerinize göre özelleştirilmiş premium deneyimler"
          },
          trust: {
            title: "Güven",
            description: "Güvenilirlik yoluyla kalıcı ilişkiler kuruyoruz"
          }
        }
      },
      stats: {
        experience: "Yıllık Deneyim",
        clients: "Mutlu Müşteri",
        satisfaction: "Müşteri Memnuniyeti"
      },
      location: {
        title: "Konumumuz",
        description: "Türkiye'nin Side ilçesinin kalbinde, tarihi limanın yakınında yer almaktayız. Türk Rivierası boyunca yat kiralama ihtiyaçlarınız için ideal konumdayız.",
        contact: {
          title: "İletişim Bilgileri",
          address: "Side Limanı, Side, Apollon Sk., 07600 Manavgat/Antalya",
          phone: "+90 549 537 70 07",
          email: "side.viprental@gmail.com"
        }
      }
    },
    contact: {
      header: {
        title: "İletişim",
        subtitle: "Herhangi bir soru veya bilgi için bizimle iletişime geçin"
      },
      info: {
        phone: {
          title: "Telefon",
          numbers: [
            "+90 549 537 70 07",
            "+90 549 537 70 07"
          ]
        },
        email: {
          title: "E-posta",
          addresses: [
            "info@sidevipyacht.com",
            "support@sidevipyacht.com"
          ]
        },
        location: {
          title: "Konum",
          address: [
            "Side Limanı, Side, Apollon Sk., 07600 Manavgat/Antalya",
            "Side, Antalya, Türkiye"
          ]
        }
      },
      form: {
        title: "Bize mesaj gönderin",
        fields: {
          name: {
            label: "İsim",
            placeholder: "Adınız"
          },
          email: {
            label: "E-posta",
            placeholder: "E-posta adresiniz",
            hint: "Size ulaşmamızı istediğiniz e-posta adresini ekleyin"
          },
          phone: {
            label: "Telefon",
            placeholder: "+90 XXX XXX XXXX",
            hint: "Size ulaşmamızı istediğiniz telefon numarasını ekleyin"
          },
          subject: {
            label: "Konu",
            placeholder: "Mesaj konusu"
          },
          message: {
            label: "Mesaj",
            placeholder: "Mesajınız"
          }
        },
        submitButton: "Mesaj Gönder"
      }
    },
    timeOptions: {
      title: "Zamanınızı Seçin",
      morning: "Sabah Turu",
      afternoon: "Öğleden Sonra Turu",
      sunset: "Gün Batımı Turu",
      fullDay: "Tam Gün Tur",
      morningTime: "10:00 - 14:00",
      afternoonTime: "14:00 - 18:00",
      sunsetTime: "18:00 - 22:00",
      fullDayTime: "10:00 - 18:00"
    },
    paymentContact: {
      title: "Rezervasyon için İletişim",
      yacht: "Seçilen Yat",
      price: "Başlangıç Fiyatı",
      messageTemplate: "Merhaba, {yachtName} için rezervasyon yaptırmak istiyorum",
      emailSubject: "{yachtName} için Rezervasyon Talebi",
      buttons: {
        whatsapp: "WhatsApp ile İletişim",
        telegram: "Telegram ile İletişim",
        email: "E-posta ile İletişim"
      }
    },
    maps: {
      sectionTitle: {
        subtitle: "KONUMUMUZ",
        title: "Bizi Burada Bulun"
      },
      title: "Konumumuz",
      markerTitle: "Side VIP Yat Kiralama",
      popup: "Yat Kiralama Konumumuz"
    },
    yachtDetails: {
      header: {
        price: "Başlangıç fiyatı"
      },
      description: {
        title: "Açıklama",
        specialOffer: "FİYATA DAHİL OLAN ÖZEL TEKLİFİMİZ",
        readMore: "Devamını Oku...",
        location: {
          departure: "Kalkış Marinası"
        },
        menu: {
          title: "Menü",
          beverages: "Meyveli Alkolsüz İçecekler"
        },
        extraServices: {
          title: "FİYATA DAHİL OLMAYAN EKSTRA HİZMETLER VE İSTEKLER İÇİN"
        }
      },
      features: {
        title: "Özellikleri",
        labels: {
          yachtName: "Yat Adı",
          yachtType: "Yat Tipi",
          brand: "Marka",
          capacity: "Kapasite",
          crew: "Mürettebat",
          cabin: "Kabin",
          showerWC: "Duş/WC",
          length: "Uzunluk",
          width: "Genişlik",
          speed: "Hız",
          manufacturing: "Üretim Yılı",
          refitDate: "Yenileme Tarihi",
          location: "Konum",
          distance: "Mesafe"
        }
      },
      equipment: {
        title: "Ekipman",
        comfort: "Konfor Ekipmanları",
        activities: "Aktiviteler"
      },
      services: {
        included: {
          foodAndBeverage: {
            title: "Yiyecek ve İçecek",
            description: "Ücretsiz menü ve alkolsüz içecekler dahildir."
          },
          decoration: {
            title: "Dekorasyon",
            description: "Özel günler için özel dekorasyonlar mevcuttur."
          },
          fuel: {
            title: "Yakıt",
            description: "Tüm yakıt masrafları fiyata dahildir."
          },
          waiterAndCrew: {
            title: "Garson ve Mürettebat",
            description: "Profesyonel mürettebat hizmeti dahildir."
          },
          fixedMenu: {
            title: "Sabit Menü İçeriği"
          }
        },
        extras: {
          birthdayCake: {
            title: "Doğum Günü Pastası",
            description: "İsteğe özel doğum günü pastaları mevcuttur."
          },
          bringingAlcohol: {
            title: "Alkol Getirme",
            description: "Kendi alkolünüzü getirmek için 25€ servis ücreti."
          },
          purchasingAlcohol: {
            title: "Alkol Satın Alma",
            description: "Teknede satın alma mevcuttur."
          },
          modifyingMenu: {
            title: "Menü Değişiklikleri",
            description: "Ek ücretle özel menü seçenekleri mevcuttur."
          },
          tourRouteChange: {
            title: "Rota Değişiklikleri",
            description: "Ek süre ücretiyle esnek rotalama."
          },
          waterActivities: {
            title: "Su Aktiviteleri",
            description: "Ek ücretle su sporları mevcuttur."
          },
          photographyServices: {
            title: "Fotoğrafçılık",
            description: "Profesyonel fotoğraf hizmetleri mevcuttur."
          },
          transfer: {
            title: "Transfer",
            description: "Grup büyüklüğüne göre özel transfer hizmetleri."
          }
        }
      },
      imageViewer: {
        close: "Kapat",
        prev: "Önceki",
        next: "Sonraki"
      }
    },
    yachtData: {
      priceUnit: "günlük",
      description: {
        highlights: "Öne Çıkanlar",
        location: {
          departure: "Kalkış",
          route: "Rota"
        }
      },
      features: {
        title: "Özellikler",
        labels: {
          yachtName: "Yat Adı",
          yachtType: "Yat Tipi",
          brand: "Marka",
          capacity: "Kapasite",
          crew: "Mürettebat",
          cabin: "Kabin",
          showerWC: "Duş/WC",
          length: "Uzunluk",
          width: "Genişlik",
          speed: "Hız",
          manufacturing: "Üretim Yılı",
          refitDate: "Yenileme Tarihi",
          location: "Konum",
          distance: "Mesafe"
        }
      },
      equipment: {
        title: "Ekipman",
        comfort: "Konfor Ekipmanları",
        activities: "Aktiviteler"
      },
      services: {
        included: {
          foodAndBeverage: {
            title: "Yiyecek ve İçecek",
            description: "Ücretsiz menü ve alkolsüz içecekler dahildir."
          },
          decoration: {
            title: "Dekorasyon",
            description: "Özel günler için özel dekorasyonlar mevcuttur."
          },
          fuel: {
            title: "Yakıt",
            description: "Tüm yakıt masrafları fiyata dahildir."
          },
          waiterAndCrew: {
            title: "Garson ve Mürettebat",
            description: "Profesyonel mürettebat hizmeti dahildir."
          },
          fixedMenu: {
            title: "Sabit Menü İçeriği"
          }
        },
        extras: {
          birthdayCake: {
            title: "Doğum Günü Pastası",
            description: "İsteğe özel doğum günü pastaları mevcuttur."
          },
          bringingAlcohol: {
            title: "Alkol Getirme",
            description: "Kendi alkolünüzü getirmek için 25€ servis ücreti."
          },
          purchasingAlcohol: {
            title: "Alkol Satın Alma",
            description: "Teknede satın alma mevcuttur."
          },
          modifyingMenu: {
            title: "Menü Değişiklikleri",
            description: "Ek ücretle özel menü seçenekleri mevcuttur."
          },
          tourRouteChange: {
            title: "Rota Değişiklikleri",
            description: "Ek süre ücretiyle esnek rotalama."
          },
          waterActivities: {
            title: "Su Aktiviteleri",
            description: "Ek ücretle su sporları mevcuttur."
          },
          photographyServices: {
            title: "Fotoğrafçılık",
            description: "Profesyonel fotoğraf hizmetleri mevcuttur."
          },
          transfer: {
            title: "Transfer",
            description: "Grup büyüklüğüne göre özel transfer hizmetleri."
          }
        }
      }
    }
  },
  de: {
    navbar: {
      home: "Startseite",
      about: "Über uns",
      yachts: "Yachten",
      contact: "Kontakt",
      language: "Sprache"
    },
    hero: {
      label: "EXKLUSIVE YACHTERLEBNISSE",
      title: "Begeben Sie sich auf eine\nReise voller Eleganz und\nAbenteuer mit unseren Yachten",
      description: "Entdecken Sie die atemberaubende Schönheit der Küste mit unseren Luxusyachttouren. Von Sides historischem Hafen aus erkunden Sie versteckte Meereshöhlen, unberührte Strände und legendäre Wahrzeichen.",
      button: "YACHT RESERVIEREN →"
    },
    welcome: {
      title: "Entdecken Sie Ihr perfektes Yachtabenteuer",
      subtitle: "Erleben Sie Luxus und Freiheit an der türkischen Riviera",
      description: "Begeben Sie sich auf eine unvergessliche Reise entlang der atemberaubenden türkischen Küste, wo kristallklares Wasser auf antike Geschichte und modernen Luxus trifft.",
      features: {
        premium: {
          title: "Premium-Yachten",
          description: "Wählen Sie aus unserer Flotte sorgfältig gewarteter Luxusschiffe"
        },
        routes: {
          title: "Individuelle Routen",
          description: "Maßgeschneiderte Reiserouten nach Ihren Wünschen"
        },
        crew: {
          title: "Erfahrene Crew",
          description: "Professionelle und erfahrene Crew zu Ihren Diensten"
        },
        luxury: {
          title: "Luxuserlebnis",
          description: "Erstklassige Annehmlichkeiten und Gourmet-Speisen"
        }
      }
    },
    features: {
      yachtCharters: {
        title: "Luxus-Yachtcharter",
        description: "Segeln Sie stilvoll mit unserer Flotte von Premium-Yachten, die unvergleichlichen Komfort und Eleganz bieten."
      },
      service: {
        title: "Außergewöhnlicher Service",
        description: "Unsere engagierte Crew sorgt für ein nahtloses und unvergessliches Erlebnis und erfüllt jeden Ihrer Wünsche."
      },
      fleet: {
        title: "Erstklassige Flotte",
        description: "Unsere Yachten werden nach höchsten Standards gewartet und garantieren eine sichere und luxuriöse Reise."
      }
    },
    yachtListings: {
      title: "SPEZIELLE YACHTTOUREN",
      subtitle: "Unsere Luxusyachtflotte",
      viewAll: "Alle Yachten ansehen",
      details: {
        capacity: "Kapazität",
        cabins: "Kabinen",
        location: "Standort"
      }
    },
    infoSection: {
      banner: {
        title: "Entdecken Sie heute eine fantastische Luxusyacht!",
        button: "JETZT BUCHEN →"
      },
      images: {
        mainImageAlt: "Luxusyacht bei Sonnenuntergang",
        overlayImageAlt: "Kapitän steuert die Yacht",
        promoImageAlt: "Luxusyacht-Erlebnis"
      },
      discover: {
        label: "ENTDECKEN",
        title: "Beste Yacht entdecken",
        description1: "Unsere Side Yacht Tour findet auf einer familiengeführten Yacht statt. Wenn Sie mit dieser Art von Schiff nicht vertraut sind, handelt es sich um ein häufig in der Südwesttürkei und der östlichen Mittelmeer gefundenes Holzsegelboot.",
        description2: "Das Schiff wird Ihnen für den Tag und ist mit modernen Toiletten, TV's, bequemen Kissen, Liegen und Sitzen auf dem Boot ausgestattet."
      },
      benefits: {
        expertise: {
          title: "Lokale Expertise",
          description: "Unsere erfahrene Crew kennt jeden versteckten Schatz entlang der türkischen Küste und garantiert ein authentisches Erlebnis."
        },
        service: {
          title: "Premium-Service",
          description: "Erstklassige Annehmlichkeiten und engagierte Crew zu Ihren Diensten."
        },
        personalized: {
          title: "Personalisierter Service",
          description: "Maßgeschneiderte Reiserouten und Premium-Bordservice, der Ihre Erwartungen übertrifft."
        }
      },
      features: {
        label: "EIGENSCHAFTEN",
        title: "Erleben Sie Luxus",
        description: "Entdecken Sie die perfekte Mischung aus Komfort und Abenteuer"
      },
      charter: {
        title: "Privatcharter",
        description: "Exklusive Yachterlebnisse nach Ihren Wünschen"
      },
      amenities: {
        title: "Moderne Annehmlichkeiten",
        description: "Vollständig ausgestattet mit modernsten Komfortmerkmalen"
      },
      crew: {
        title: "Professionelle Crew",
        description: "Erfahrenes und engagiertes Team zu Ihren Diensten"
      },
      promo: {
        title: "Spezielle Sommerangebote",
        description: "Buchen Sie jetzt Ihr Traumyachterlebnis und genießen Sie bis zu 20% Rabatt auf ausgewählte Termine. Frühbucherrabatte und flexible Buchungsoptionen verfügbar.",
        button: "ANGEBOTE ANSEHEN"
      }
    },
    tourRoadmap: {
      title: "TOURROUTE",
      subtitle: "Ihre Reise mit uns",
      description: "Erleben Sie einen unvergesslichen Tag beim Erkunden der wunderschönen Mittelmeerküste",
      stops: [
        {
          time: "10:00",
          location: "Side Hafen",
          description: "Abfahrt vom Side Hafen"
        },
        {
          time: "10:30",
          location: "Schwimmpause",
          description: "Erster Schwimm- und Schnorchelstop"
        },
        {
          time: "12:30",
          location: "Mittagspause und Schwimmen",
          description: "Genießen Sie mediterranes Mittagessen"
        },
        {
          time: "14:00",
          location: "Schwimmpause",
          description: "Zweite Schwimm- und Entspannungszeit"
        },
        {
          time: "15:00",
          location: "Side Hafen",
          description: "Rückkehr zum Side Hafen"
        }
      ]
    },
    about: {
      hero: {
        title: "Side VIP Yacht Charter",
        subtitle: "Unvergessliche Maritime Erlebnisse seit 2020"
      },
      story: {
        title: "Unsere Geschichte",
        description1: "Side VIP Yacht Charter wurde 2020 gegründet und hat sich als erstklassiger Luxusyachtcharter-Service in Side, Türkei, etabliert. Unsere Reise begann mit einer einfachen Vision: außergewöhnliche maritime Erlebnisse zu bieten, die Luxus, Komfort und Abenteuer vereinen.",
        description2: "Heute sind wir stolz auf unsere Flotte sorgfältig gewarteter Yachten und unser engagiertes Team erfahrener Profis, die dafür sorgen, dass jede Reise die Erwartungen übertrifft."
      },
      values: {
        title: "Unsere Werte",
        cards: {
          excellence: {
            title: "Exzellenz",
            description: "Wir streben in jedem Aspekt unseres Service nach Exzellenz"
          },
          safety: {
            title: "Sicherheit zuerst",
            description: "Ihre Sicherheit hat bei jeder Reise oberste Priorität"
          },
          luxury: {
            title: "Luxusservice",
            description: "Premium-Erlebnisse nach Ihren Wünschen"
          },
          trust: {
            title: "Vertrauen",
            description: "Aufbau dauerhafter Beziehungen durch Zuverlässigkeit"
          }
        }
      },
      stats: {
        experience: "Jahre Erfahrung",
        clients: "Zufriedene Kunden",
        satisfaction: "Kundenzufriedenheit"
      },
      location: {
        title: "Unser Standort",
        description: "Im Herzen von Side, Türkei, günstig in der Nähe des historischen Hafens gelegen. Wir sind perfekt positioniert, um Ihre Yachtcharter-Bedürfnisse entlang der türkischen Riviera zu erfüllen.",
        contact: {
          title: "Kontaktinformationen",
          address: "Side Harbour, Side, Apollon Sk., 07600 Manavgat/Antalya",
          phone: "+90 549 537 70 07",
          email: "side.viprental@gmail.com"
        }
      }
    },
    contact: {
      header: {
        title: "Kontakt",
        subtitle: "Kontaktieren Sie uns für Fragen oder Anfragen"
      },
      info: {
        phone: {
          title: "Telefon",
          numbers: [
            "+90 549 537 70 07",
            "+90 549 537 70 07"
          ]
        },
        email: {
          title: "E-Mail",
          addresses: [
            "info@sidevipyacht.com",
            "support@sidevipyacht.com"
          ]
        },
        location: {
          title: "Standort",
          address: [
            "Side Harbour, Side, Apollon Sk., 07600 Manavgat/Antalya",
            "Side, Antalya, Türkei"
          ]
        }
      },
      form: {
        title: "Senden Sie uns eine Nachricht",
        fields: {
          name: {
            label: "Name",
            placeholder: "Ihr Name"
          },
          email: {
            label: "E-Mail",
            placeholder: "Ihre E-Mail-Adresse",
            hint: "Fügen Sie Ihre E-Mail-Adresse hinzu, unter der wir Sie kontaktieren sollen"
          },
          phone: {
            label: "Telefon",
            placeholder: "+90 XXX XXX XXXX",
            hint: "Fügen Sie Ihre Telefonnummer hinzu, unter der wir Sie kontaktieren sollen"
          },
          subject: {
            label: "Betreff",
            placeholder: "Nachrichtenbetreff"
          },
          message: {
            label: "Nachricht",
            placeholder: "Ihre Nachricht"
          }
        },
        submitButton: "Nachricht Senden"
      }
    },
    timeOptions: {
      title: "Wählen Sie Ihre Zeit",
      morning: "Morgentour",
      afternoon: "Nachmittagstour",
      sunset: "Sonnenuntergangstour",
      fullDay: "Ganztagestour",
      morningTime: "10:00 - 14:00",
      afternoonTime: "14:00 - 18:00",
      sunsetTime: "18:00 - 22:00",
      fullDayTime: "10:00 - 18:00"
    },
    paymentContact: {
      title: "Kontakt für Buchung",
      yacht: "Ausgewählte Yacht",
      price: "Startpreis",
      messageTemplate: "Hallo, ich interessiere mich für die Buchung der {yachtName}",
      emailSubject: "Buchungsanfrage für {yachtName}",
      buttons: {
        whatsapp: "Kontakt via WhatsApp",
        telegram: "Kontakt via Telegram",
        email: "Kontakt via E-Mail"
      }
    },
    maps: {
      sectionTitle: {
        subtitle: "UNSER STANDORT",
        title: "Finden Sie uns hier"
      },
      title: "Unser Standort",
      markerTitle: "Side VIP Yacht Charter",
      popup: "Unser Yachtverleih Standort"
    },
    yachtDetails: {
      header: {
        price: "Ab"
      },
      description: {
        title: "Beschreibung",
        specialOffer: "UNSER SPEZIELLES ANGEBOT IM PREIS INBEGRIFFEN",
        readMore: "Mehr lesen...",
        location: {
          departure: "Abfahrtsmarina"
        },
        menu: {
          title: "Menü",
          beverages: "Fruchtige Erfrischungsgetränke"
        },
        extraServices: {
          title: "FÜR ZUSÄTZLICHE SERVICES UND ANFRAGEN NICHT IM PREIS ENTHALTEN"
        }
      },
      features: {
        title: "Die Eigenschaften von",
        labels: {
          yachtName: "Yachtname",
          yachtType: "Yachttyp",
          brand: "Marke",
          capacity: "Kapazität",
          crew: "Besatzung",
          cabin: "Kabinen",
          showerWC: "Dusche/WC",
          length: "Länge",
          width: "Breite",
          speed: "Geschwindigkeit",
          manufacturing: "Baujahr",
          refitDate: "Renovierungsdatum",
          location: "Standort",
          distance: "Entfernung"
        }
      },
      equipment: {
        title: "Die Ausstattung von"
      },
      services: {
        included: {
          title: "Im Preis enthalten",
          fixedMenu: {
            title: "Festes Menü"
          }
        },
        extras: {
          title: "Verfügbare Extras"
        }
      },
      imageViewer: {
        close: "Schließen",
        prev: "Vorheriges",
        next: "Nächstes"
      }
    },
    yachtData: {
      priceUnit: "pro Tag",
      description: {
        highlights: "Highlights",
        location: {
          departure: "Abfahrt",
          route: "Route"
        }
      },
      features: {
        title: "Eigenschaften",
        labels: {
          yachtName: "Yachtname",
          yachtType: "Yachttyp",
          brand: "Marke",
          capacity: "Kapazität",
          crew: "Besatzung",
          cabin: "Kabinen",
          showerWC: "Dusche/WC",
          length: "Länge",
          width: "Breite",
          speed: "Geschwindigkeit",
          manufacturing: "Baujahr",
          refitDate: "Renovierungsdatum",
          location: "Standort",
          distance: "Entfernung"
        }
      },
      equipment: {
        title: "Ausstattung",
        comfort: "Komfortausstattung",
        activities: "Aktivitäten"
      },
      services: {
        included: {
          foodAndBeverage: {
            title: "Speisen und Getränke",
            description: "Kostenloses Menü und alkoholfreie Getränke inklusive."
          },
          decoration: {
            title: "Dekoration",
            description: "Spezielle Dekorationen für besondere Anlässe verfügbar."
          },
          fuel: {
            title: "Treibstoff",
            description: "Alle Treibstoffkosten im Charterpreis enthalten."
          },
          waiterAndCrew: {
            title: "Kellner und Crew",
            description: "Professioneller Crew-Service inklusive."
          },
          fixedMenu: {
            title: "Festes Menüangebot"
          }
        },
        extras: {
          birthdayCake: {
            title: "Geburtstagstorte",
            description: "Individuelle Geburtstagstorten auf Anfrage."
          },
          bringingAlcohol: {
            title: "Alkohol Mitbringen",
            description: "25€ Servicegebühr für mitgebrachten Alkohol."
          },
          purchasingAlcohol: {
            title: "Alkohol Kaufen",
            description: "An Bord erhältlich."
          },
          modifyingMenu: {
            title: "Menüänderungen",
            description: "Individuelle Menüoptionen gegen Aufpreis."
          },
          tourRouteChange: {
            title: "Routenänderungen",
            description: "Flexible Routenplanung mit Zeitaufschlag."
          },
          waterActivities: {
            title: "Wasseraktivitäten",
            description: "Zusätzliche Wassersportmöglichkeiten gegen Gebühr."
          },
          photographyServices: {
            title: "Fotografie",
            description: "Professionelle Fotoservices verfügbar."
          },
          transfer: {
            title: "Transfer",
            description: "Individuelle Transferservices je nach Gruppengröße."
          }
        }
      }
    }
  },
  ru: {
    navbar: {
      home: "Главная",
      about: "О нас",
      yachts: "Яхты",
      contact: "Контакты",
      language: "Язык"
    },
    hero: {
      label: "ЭКСКЛЮЗИВНЫЕ ЯХТЕННЫЕ ТУРЫ",
      title: "Отправьтесь в путешествие\nэлегантности и приключений\nна наших яхтах",
      description: "Откройте для себя захватывающую красоту побережья с нашими роскошными яхтенными турами. Отправляясь из исторической гавани Сиде, исследуйте скрытые морские пещеры, нетронутые пляжи и знаковые достопримечательности.",
      button: "ЗАБРОНИРОВАТЬ ЯХТУ →"
    },
    welcome: {
      title: "Откройте для себя идеальное яхтенное приключение",
      subtitle: "Испытайте роскошь и свободу на Турецкой Ривьере",
      description: "Отправьтесь в незабываемое путешествие вдоль потрясающего побережья Турции, где кристально чистые воды встречаются с древней историей и современной роскошью.",
      features: {
        premium: {
          title: "Премиум яхты",
          description: "Выберите из нашего флота тщательно обслуживаемых роскошных судов"
        },
        routes: {
          title: "Индивидуальные маршруты",
          description: "Персонализированные маршруты, учитывающие ваши предпочтения"
        },
        crew: {
          title: "Опытный экипаж",
          description: "Профессиональный и опытный экипаж к вашим услугам"
        },
        luxury: {
          title: "Роскошный опыт",
          description: "Первоклассные удобства и гурме-питание"
        }
      }
    },
    features: {
      yachtCharters: {
        title: "Аренда роскошных яхт",
        description: "Путешествуйте стильно на наших премиальных яхтах, предлагающих непревзойденный комфорт и элегантность."
      },
      service: {
        title: "Исключительный сервис",
        description: "Наш преданный экипаж обеспечивает безупречный и незабываемый опыт, удовлетворяя все ваши потребности."
      },
      fleet: {
        title: "Первоклассный флот",
        description: "Наши яхты поддерживаются в соответствии с высочайшими стандартами, обеспечивая безопасное и роскошное путешествие."
      }
    },
    yachtListings: {
      title: "СПЕЦИАЛЬНЫЕ ЯХТЕННЫЕ ТУРЫ",
      subtitle: "Наш флот роскошных яхт",
      viewAll: "Посмотреть все яхты",
      details: {
        capacity: "Вместимость",
        cabins: "Каюты",
        location: "Местоположение"
      }
    },
    infoSection: {
      banner: {
        title: "Откройте для себя удивительную роскошную яхту сегодня!",
        button: "ЗАБРОНИРОВАТЬ СЕЙЧАС →"
      },
      images: {
        mainImageAlt: "Роскошная яхта на закате",
        overlayImageAlt: "Капитан управляет яхтой",
        promoImageAlt: "Роскошный яхтенный опыт"
      },
      discover: {
        label: "ОТКРЫТЬ",
        title: "Откройте лучшую яхту",
        description1: "Наш тур на яхте Side проходит на семейной яхте. Если вы не знакомы с этим типом судна, это деревянное парусное судно, распространенное на юго-западе Турции и в восточном Средиземноморье.",
        description2: "Судно будет в вашем распоряжении весь день и оборудовано современными туалетами, телевизорами, удобными подушками, шезлонгами и сиденьями на борту."
      },
      benefits: {
        expertise: {
          title: "Локальная Экспертиза",
          description: "Наш опытный экипаж знает каждую скрытую жемчужину вдоль турецкого побережья для аутентичного опыта."
        },
        service: {
          title: "Премиум Сервис",
          description: "Первоклассные удобства и преданный экипаж к вашим услугам."
        },
        personalized: {
          title: "Персонализированный Сервис",
          description: "Индивидуальные маршруты и премиальные услуги на борту, превосходящие ваши ожидания."
        }
      },
      features: {
        label: "ХАРАКТЕРИСТИКИ",
        title: "Испытайте Роскошь",
        description: "Откройте для себя идеальное сочетание комфорта и приключений"
      },
      charter: {
        title: "Частная Аренда",
        description: "Эксклюзивные яхтенные туры по вашим предпочтениям"
      },
      amenities: {
        title: "Современные Удобства",
        description: "Полностью оборудован новейшими функциями комфорта"
      },
      crew: {
        title: "Профессиональный Экипаж",
        description: "Опытная и преданная команда к вашим услугам"
      },
      promo: {
        title: "Специальные Летние Предложения",
        description: "Забронируйте яхту своей мечты сейчас и получите скидку до 20% на выбранные даты. Доступны скидки за раннее бронирование и гибкие условия.",
        button: "СМОТРЕТЬ ПРЕДЛОЖЕНИЯ"
      }
    },
    tourRoadmap: {
      title: "МАРШРУТ ТУРА",
      subtitle: "Ваше путешествие с нами",
      description: "Проведите незабываемый день, исследуя прекрасное Средиземноморское побережье",
      stops: [
        {
          time: "10:00",
          location: "Порт Сиде",
          description: "Отправление из порта Сиде"
        },
        {
          time: "10:30",
          location: "Остановка для купания",
          description: "Первая остановка для плавания и снорклинга"
        },
        {
          time: "12:30",
          location: "Обед и купание",
          description: "Наслаждайтесь обедом средиземноморской кухни"
        },
        {
          time: "14:00",
          location: "Остановка для купания",
          description: "Второе время для плавания и отдыха"
        },
        {
          time: "15:00",
          location: "Порт Сиде",
          description: "Возвращение в порт Сиде"
        }
      ]
    },
    about: {
      hero: {
        title: "О компании Side Vip Yacht Charter",
        subtitle: "Создаем незабываемые морские впечатления с 2020 года"
      },
      story: {
        title: "Наша История",
        description1: "Основанная в 2020 году, компания Side VIP Yacht Charter зарекомендовала себя как премиальный сервис по аренде яхт в Сиде, Турция. Наш путь начался с простого видения: предоставлять исключительные морские впечатления, сочетающие роскошь, комфорт и приключения.",
        description2: "Сегодня мы гордимся нашим флотом тщательно обслуживаемых яхт и нашей преданной командой опытных профессионалов, которые обеспечивают превосходство каждого путешествия над ожиданиями."
      },
      values: {
        title: "Наши Ценности",
        cards: {
          excellence: {
            title: "Совершенство",
            description: "Мы стремимся к совершенству в каждом аспекте нашего сервиса"
          },
          safety: {
            title: "Безопасность прежде всего",
            description: "Ваша безопасность - наш главный приоритет в каждом путешествии"
          },
          luxury: {
            title: "Люкс Сервис",
            description: "Премиальный опыт, адаптированный под ваши предпочтения"
          },
          trust: {
            title: "Доверие",
            description: "Построение долгосрочных отношений через надежность"
          }
        }
      },
      stats: {
        experience: "Лет опыта",
        clients: "Довольных клиентов",
        satisfaction: "Удовлетворенность клиентов"
      },
      location: {
        title: "Наше Расположение",
        description: "Расположены в сердце Сиде, Турция, удобно рядом с историческим портом. Мы идеально расположены для обслуживания ваших потребностей в аренде яхт вдоль Турецкой Ривьеры.",
        contact: {
          title: "Контактная Информация",
          address: "Side Harbour, Сиде, Apollon Sk., 07600 Манавгат/Анталья",
          phone: "+90 549 537 70 07",
          email: "side.viprental@gmail.com"
        }
      }
    },
    contact: {
      header: {
        title: "Контакты",
        subtitle: "Свяжитесь с нами по любым вопросам"
      },
      info: {
        phone: {
          title: "Телефон",
          numbers: [
            "+90 549 537 70 07",
            "+90 549 537 70 07"
          ]
        },
        email: {
          title: "Эл. почта",
          addresses: [
            "info@sidevipyacht.com",
            "support@sidevipyacht.com"
          ]
        },
        location: {
          title: "Расположение",
          address: [
            "Side Harbour, Сиде, Apollon Sk., 07600 Манавгат/Анталья",
            "Сиде, Анталья, Турция"
          ]
        }
      },
      form: {
        title: "Отправьте нам сообщение",
        fields: {
          name: {
            label: "Имя",
            placeholder: "Ваше имя"
          },
          email: {
            label: "Эл. почта",
            placeholder: "Ваш адрес эл. почты",
            hint: "Добавьте адрес эл. почты, по которому мы можем с вами связаться"
          },
          phone: {
            label: "Телефон",
            placeholder: "+90 XXX XXX XXXX",
            hint: "Добавьте номер телефона, по которому мы можем с вами связаться"
          },
          subject: {
            label: "Тема",
            placeholder: "Тема сообщения"
          },
          message: {
            label: "Сообщение",
            placeholder: "Ваше сообщение"
          }
        },
        submitButton: "Отправить Сообщение"
      }
    },
    timeOptions: {
      title: "Выберите время",
      morning: "Утренний тур",
      afternoon: "Дневной тур",
      sunset: "Закатный тур",
      fullDay: "Полный день",
      morningTime: "10:00 - 14:00",
      afternoonTime: "14:00 - 18:00",
      sunsetTime: "18:00 - 22:00",
      fullDayTime: "10:00 - 18:00"
    },
    paymentContact: {
      title: "Контакты для бронирования",
      yacht: "Выбранная яхта",
      price: "Начальная цена",
      messageTemplate: "Здравствуйте, я хочу забронировать {yachtName}",
      emailSubject: "Запрос на бронирование {yachtName}",
      buttons: {
        whatsapp: "Связаться через WhatsApp",
        telegram: "Связаться через Telegram",
        email: "Связаться по email"
      }
    },
    maps: {
      sectionTitle: {
        subtitle: "НАШЕ МЕСТОПОЛОЖЕНИЕ",
        title: "Найдите нас здесь"
      },
      title: "Наше местоположение",
      markerTitle: "Side VIP Yacht Charter",
      popup: "Место аренды яхт"
    },
    yachtDetails: {
      header: {
        price: "Начальная цена"
      },
      description: {
        title: "Описание",
        specialOffer: "НАШЕ СПЕЦИАЛЬНОЕ ПРЕДЛОЖЕНИЕ, ВКЛЮЧЕННОЕ В ЦЕНУ",
        readMore: "Читать далее...",
        location: {
          departure: "Марина отправления"
        },
        menu: {
          title: "Меню",
          beverages: "Фруктовые безалкогольные напитки"
        },
        extraServices: {
          title: "ДЛЯ ДОПОЛНИТЕЛЬНЫХ УСЛУГ И ЗАПРОСОВ, НЕ ВКЛЮЧЕННЫХ В ЦЕНУ"
        }
      },
      features: {
        title: "Характеристики",
        labels: {
          yachtName: "Название яхты",
          yachtType: "Тип яхты",
          brand: "Бренд",
          capacity: "Вместимость",
          crew: "Экипаж",
          cabin: "Каюта",
          showerWC: "Душ/туалет",
          length: "Длина",
          width: "Ширина",
          speed: "Скорость",
          manufacturing: "Производство",
          refitDate: "Дата реновации",
          location: "Местоположение",
          distance: "Расстояние"
        }
      },
      equipment: {
        title: "Оборудование"
      },
      services: {
        included: {
          title: "Включено в цену",
          fixedMenu: {
            title: "Фиксированное меню"
          }
        },
        extras: {
          title: "Доступные дополнения"
        }
      },
      imageViewer: {
        close: "Закрыть",
        prev: "Предыдущее",
        next: "Следующее"
      }
    },
    yachtData: {
      priceUnit: "в день",
      description: {
        highlights: "Особенности",
        location: {
          departure: "Отправление",
          route: "Маршрут"
        }
      },
      features: {
        title: "Характеристики",
        labels: {
          yachtName: "Название яхты",
          yachtType: "Тип яхты",
          brand: "Бренд",
          capacity: "Вместимость",
          crew: "Экипаж",
          cabin: "Каюта",
          showerWC: "Душ/Туалет",
          length: "Длина",
          width: "Ширина",
          speed: "Скорость",
          manufacturing: "Год постройки",
          refitDate: "Дата реновации",
          location: "Местоположение",
          distance: "Расстояние"
        }
      },
      equipment: {
        title: "Оборудование",
        comfort: "Комфортное оборудование",
        activities: "Активности"
      },
      services: {
        included: {
          foodAndBeverage: {
            title: "Питание и напитки",
            description: "Бесплатное меню и безалкогольные напитки включены."
          },
          decoration: {
            title: "Украшение",
            description: "Доступно специальное оформление для особых случаев."
          },
          fuel: {
            title: "Топливо",
            description: "Все расходы на топливо включены в стоимость."
          },
          waiterAndCrew: {
            title: "Официант и экипаж",
            description: "Профессиональное обслуживание экипажем включено."
          },
          fixedMenu: {
            title: "Стандартное меню"
          }
        },
        extras: {
          birthdayCake: {
            title: "Торт ко дню рождения",
            description: "Доступны индивидуальные торты на заказ."
          },
          bringingAlcohol: {
            title: "Свой алкоголь",
            description: "Сервисный сбор 25€ за свой алкоголь."
          },
          purchasingAlcohol: {
            title: "Покупка алкоголя",
            description: "Доступно для покупки на борту."
          },
          modifyingMenu: {
            title: "Изменение меню",
            description: "Индивидуальные опции меню за дополнительную плату."
          },
          tourRouteChange: {
            title: "Изменение маршрута",
            description: "Гибкая маршрутизация с доплатой за время."
          },
          waterActivities: {
            title: "Водные развлечения",
            description: "Дополнительные водные виды спорта за отдельную плату."
          },
          photographyServices: {
            title: "Фотосъемка",
            description: "Доступны услуги профессиональной фотосъемки."
          },
          transfer: {
            title: "Трансфер",
            description: "Индивидуальные услуги трансфера в зависимости от размера группы."
          }
        }
      }
    }
  }
}; 